import XLSX from 'xlsx';
/* generate an array of column objects */
export const make_cols = refstr => {
	// let o = [] 
	
	if( typeof refstr == "undefined" || refstr == "A1") {
	
	const NodataFile = "No data in file"
		return NodataFile;
	}
	else {
	var C = XLSX.utils.decode_range(refstr);
	C.s.r = 10;
	refstr = XLSX.utils.encode_range(C)
	// for(var i = 0; i < C; ++i) o[i] = {name:XLSX.utils.encode_col(i), key:i}
	return refstr;
	}
	// let o = ["Site Accounting Data","Site Number","Site Description","Supplier Name","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"]
	// return o;
};